/* eslint-disable react/jsx-one-expression-per-line */
import { ReactElement, useContext, useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { Alert, Button, DateInput, Modal, TextInput } from '@components';
import { navigateToError } from '@utils';
import VicFinesContext from '@pages/forms/VicFinesFormContext';
import InfoIcon from '../../../../images/info.svg';
import QuestionIcon from '../../../../images/question.svg';

import styles from './CourtStep2.module.scss';

const { REACT_APP_SITECORE_API_ENDPOINT: API_URL } = process.env;

function CourtStep2(): ReactElement {
  const [loading, setLoading] = useState(true);
  const context = useFormikContext();
  const { apiError } = useContext(VicFinesContext);
  const [hasOffenceDate, setOffenceDate] = useState(false);
  const [hasHearingDate, setHearingDate] = useState(false);
  const [hasLicenceNumber, setLicenceNumber] = useState(false);
  const [hasVehicleRego, setVehicleRego] = useState(false);
  const [hasDOB, setDOB] = useState(false);
  const [isOpenHelp, setOpenHelp] = useState(false);
  const CourtStep2AlertContent = (): ReactElement => <p>{`${apiError?.Error}`}</p>;

  const closeNotifications = () => {
    setOpenHelp(false);
  };

  const notificationInformation = (): ReactElement => (
    <div className={styles.notificationDiv}>
      <div>
        <span>If you don't know these details or think we may have the wrong information, contact Fines Victoria, Monday to Friday, 8am to 6pm (except public holidays).</span>
        <p>For infringement enquiries, call <a className={styles.contactLink} href="tel:0392008111" title="Fines Victoria phone number">03 9200 8111</a> or <a className={styles.contactLink} href="tel:1300369819" title="Fines Victoria phone number">1300 369 819</a> for regional callers.</p>
        <p>For Notice of Final Demand enquiries, call <a className={styles.contactLink} href="tel:0392008222" title="Fines Victoria phone number">03 9200 8222</a> or <a className={styles.contactLink} href="tel:1800150410" title="Fines Victoria phone number">1800 150 410</a> for regional callers.</p>
      </div>
      <p className={styles.sectionTitle}>
        Do you have a Victorian driver licence?
      </p>
      <div>
        <span>If asked for your driver licence number, make sure you include any zeros at the start of your Victorian driver licence number.</span>
      </div>
      <div className={styles.btnFooter}>
        <Button
          onClick={closeNotifications}
          color="blue"
          size="small">
          Continue
        </Button>
      </div>
    </div>
  );

  useEffect(() => {
    const setupDebtor = async (formikContext: any): Promise<void> => {
      setLoading(true);
      const payload = {
        obligationNumber: formikContext.values.OBLIGATION_NUMBER,
      };
      const url = `${API_URL}sitecore/Court/SetupDebtor`;
      let response: any;
      try {
        response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        const responseBody = await response.json();
        setLoading(false);
        if (response.status === 200) {
          if (responseBody.OffenceDate) {
            setOffenceDate(true);
            context.setFieldValue('OffenceDateRequired', true);
          }
          if (responseBody.HearingDate) {
            setHearingDate(true);
            context.setFieldValue('HearingDateRequired', true);
          }
          if (responseBody.LicenceRequired) {
            setLicenceNumber(true);
            context.setFieldValue('LicenceRequired', true);
          }
          if (responseBody.RegistrationRequired) {
            setVehicleRego(true);
            context.setFieldValue('RegistrationRequired', true);
          }
          if (responseBody.DateOfBirthRequired) {
            setDOB(true);
            context.setFieldValue('DOBRequired', true);
          }
        } else navigateToError();
      } catch (error) {
        navigateToError();
      }
    };
    setupDebtor(context);
  }, []);

  return (
    <>
      {!loading && (
        <div>
          <span className="vfH2">Verify your details</span>
          {apiError?.Error && <Alert icon={InfoIcon} color="red" message={<CourtStep2AlertContent />} theme="error" />}
          {hasOffenceDate && (<Field component={DateInput} name="OFFENCE_DATE" title="Offence date" isMandatory maxDate={new Date()} />)}
          {hasHearingDate && (<Field component={DateInput} name="HEARING_DATE" title="Hearing date" isMandatory />)}
          {hasLicenceNumber && (<Field name="DRIVER_LICENCE" component={TextInput} title="Driver licence number" isMandatory />)}
          {hasVehicleRego && (<Field name="VEHICLE_REGISTRATION" component={TextInput} title="Vehicle registration number" placeholder="ABC123" isMandatory />)}
          {hasDOB && (<Field component={DateInput} name="DOB" title="Date of birth" isMandatory maxDate={new Date()} />)}
          <div>
            <button
              type="button"
              onClick={() => setOpenHelp(true)}
              className={styles.iconButton}>
              <img src={QuestionIcon} alt="help icon" />
              <span>I don't know these details</span>
            </button>
          </div>
          {isOpenHelp && (<Modal close={closeNotifications} show title="Don't know these details?" content={notificationInformation()} />)}
        </div>
      )}
    </>
  );
}

export default CourtStep2;
